import { css } from 'styled-components'

export const SharedNav = css`
  background: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.Colors.forInterface.interfaceColor13}`};
  height: 52px;
`
